import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import axios from "axios";
import { Stage, Layer, Rect, Text, Image as KonvaImage } from "react-konva";
import OwlCarousel from "react-owl-carousel";
import Constants from "../Variables/Constants";
import Y_Us_StripComponent from "../common/Y_us_strip";
import {
  Link,
  Outlet,
  useLocation,
  useParams,
  NavLink,
} from "react-router-dom";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { toast } from "react-toastify";

const Begin_To_Build_Your_Custom_Beteil = () => {
  const location = useLocation();
  const slug = location.state?.slug;
  var path = location.pathname.split("/")[1];
  let path1 = location.pathname.split("/")[3];
  if (path1 == "ColorCombinationProducts") {
    path = "ColorCombinationProducts";
  }
  if (path1 == "product") {
    path = "product";
  }
  const [allSubCategory, setAllSubcategory] = useState([]);
  const [getStyles, setAllStyles] = useState([]);
  const [activeCategoryId, setActiveCategoryId] = useState(null);
  const [subCategoryId, setSubCategoryId] = useState(null);
  const [limit, setLimit] = useState(10);
  // Canvas state
  const [bgColor, setBgColor] = useState("white");
  const [images, setImages] = useState([]);
  const [text, setText] = useState("");
  const [textRotation, setTextRotation] = useState(0);
  const [imageToShow, setImageToShow] = useState(null);
  const [textColor, setTextColor] = useState("#000000");
  const [imageWidth, setImageWidth] = useState(100); // New state for width
  const [imageHeight, setImageHeight] = useState(100); // New state for height

  const handleAddImage = (src) => {
    const img = new window.Image();
    img.src = src;
    img.onload = () => {
      setImages((prevImages) => [
        ...prevImages,
        {
          id: `image-${prevImages.length}`,
          image: img,
          x: 100,
          y: 100,
          width: 100,
          height: 100,
        },
      ]);
    };
    setImageToShow(src); // Store the image to be shown in the box
  };

  const handleImageWidthChange = (e) => {
    setImageWidth(parseInt(e.target.value, 10)); // Update width value
  };

  const handleImageHeightChange = (e) => {
    setImageHeight(parseInt(e.target.value, 10)); // Update height value
  };

  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const handleTextColorChange = (e) => {
    setTextColor(e.target.value);
  };

  const { id } = useParams();
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const resp = await axios.get(
        `${Constants.getUrls.getAllCollections}?limit=${limit}&cateId=${window.location.pathname.split("/")[2]
        }`
      );
      if (resp.data.status === "success") {
        setAllSubcategory(resp.data.data.docs);
        if (resp.data.data.docs.length > 0) {
          stylesChange(resp.data.data.docs[0]._id);
        }
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const stylesChange = (id) => {
    try {

      setActiveCategoryId(id);
      setSubCategoryId(id);
      axios
        .get(
          `${Constants.getUrls.getAllStyles}?limit=${limit}&cateId=${window.location.pathname.split("/")[2]
          }&subCatId=${id}`
        )
        .then((resp) => {
          if (resp.data.status === "success") {
            setAllStyles(resp.data.data.docs);
          }
        })
        .catch((error) => {
          console.error("Error in stylesChange:", error);
        });
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const handleClick = (id) => {
    setLimit(10);
    stylesChange(id);
  };

  const fetchMoreData = () => {
    setLimit((prevCount) => prevCount + 10);
    stylesChange(subCategoryId);
  };

  const ExploreProductsOptions = {
    navText: [
      "<i className='bi bi-chevron-left'><</i>",
      "<i className='bi bi-chevron-right'>></i>",
    ],
    items: 2,
    loop: false,
    nav: true,
    dots: false,
    responsive: {
      1: { items: 2, margin: 10 },
      600: { items: 2, margin: 10 },
    },
  };

  return (
    <>
      {path === "build_your_custom_beteil" ? (
        <section className="build_your_custom_beteil">
          <div className="container">
            <div className="row w-100 align-items-center justify-content-center mt-4">
              <div className="col-lg-6 col-md-12 col-12 mt-4">
                <div className=" text-warning text-center fs-24 fw-medium">
                  Which collection hit your eye?
                </div>
              </div>
            </div>
            {/* <div className="col-lg-4 col-md-12 col-12">
                <ul className="nav nav-pills mt-4">
                  {allSubCategory.length > 0 ? (
                    <OwlCarousel {...ExploreProductsOptions}>
                      {allSubCategory.map((category, i) => (
                        <div
                          className="item testt"
                          key={i}
                          id={`subcat_${category._id}`}
                        >
                          <li
                            className={`fs-18 py-3 text-center fw-medium rounded-4 overflow-hidden ${
                              activeCategoryId === category._id ? "Active" : ""
                            }`}
                            onClick={() => handleClick(category._id)}
                            id={`subcatli_${category._id}`}
                          >
                            {category.title}
                          </li>
                        </div>
                      ))}
                    </OwlCarousel>
                  ) : (
                    <p>Loading category...</p>
                  )}
                </ul>
              </div> */}
            {/* </div> */}
            <section className="my-5">
              {allSubCategory.length > 0 ? (
                <div className="d-flex gap-5 justify-content-center mt-4">
                  {allSubCategory.map((collection, i) => (
                    <div className="" key={i}>
                      <NavLink
                        to={`/build_your_custom_beteil/${collection._id}/ColorCombinationProducts`}
                        state={{ collectionData: collection, slug: slug }}
                      >
                        <div
                          className="size d-flex justify-content-center align-items-center text-center gap-4 bg-transparent"
                        // onClick={() => handleAddImage(`${Constants.imgDomain}${style.bagStyles}`)}
                        >
                          <img loading="lazy" 
                            className="img-fluid"
                            src={`${Constants.imgDomain}${collection.subCategory}`}
                            alt="banner-1"
                          />
                        </div>
                      </NavLink>
                      <h2 className="text-center mt-3 text-capitalize">
                        {collection.title}
                      </h2>
                    </div>
                  ))}
                </div>
              ) : (
                <p>No Data found for this category</p>
              )}
              <div className="w-100 text-center loadbtn mt-5">
                <Button variant="secondary" onClick={fetchMoreData}>
                  Load more
                </Button>
              </div>
              {/* <div className="mt-3">
                <Button variant="warning" className="fs-24 px-5 py-2 font-inter fw-semibold float-end me-7">
                  Next
                </Button>
              </div> */}
              <div className="mt-7">
                <Y_Us_StripComponent />
              </div>
            </section>
          </div>
        </section>
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default Begin_To_Build_Your_Custom_Beteil;
